import {
  orderTrackingShipmentMetricsSchema,
  orderTrackingShipmentSummarySchema,
} from "@redotech/redo-model/order-tracking/order-tracking-shipment-definition";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const orderTrackingShipmentSortKeys = [
  "orderName",
  "customerName",
  "customerEmail",
  "orderDate",
  "status",
  "trackingCode",
  "carrier",
  "deliveryStatus",
  "firstInTransitAt",
  "estimatedDeliveryAt",
  "shippingCity",
  "shippingCountry",
  "salesChannel",
] as const;

export type OrderTrackingShipmentSortKey =
  (typeof orderTrackingShipmentSortKeys)[number];

const sortKeyEnum = z.enum(orderTrackingShipmentSortKeys);

export const getOrderTrackingShipments = {
  name: "getOrderTrackingShipments" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(50),
    sortKey: sortKeyEnum.default("firstInTransitAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    shipments: z.array(orderTrackingShipmentSummarySchema),
    totalCount: z.number(),
    metrics: orderTrackingShipmentMetricsSchema,
  }),
};
